<template>
  <svg
    width="33"
    height="23"
    viewBox="0 0 33 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1138_24638)">
      <path
        d="M11.4301 6.93488H3.10339V8.04966H1.99316V10.2792H3.10339V18.6402H11.4301V6.93488Z"
        fill="white"
        stroke="#011837"
        stroke-miterlimit="10"
      />
      <path
        d="M4.76843 1.3609V6.93484"
        stroke="#011837"
        stroke-miterlimit="10"
      />
      <path
        d="M6.98889 4.14789V6.93486"
        stroke="#011837"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M5.32361 9.16443H6.43384"
        stroke="#011837"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M22.5319 9.16443H15.3154V13.6236H22.5319V9.16443Z"
        fill="#E7EEF1"
        stroke="#011837"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M15.3156 9.16443H8.09912V13.6236H15.3156V9.16443Z"
        fill="#E7EEF1"
        stroke="#011837"
        stroke-miterlimit="10"
      />
      <path
        d="M29.7486 9.16443H22.5321V13.6236H29.7486V9.16443Z"
        fill="#E7EEF1"
        stroke="#011837"
        stroke-miterlimit="10"
      />
      <path
        d="M18.6463 4.70526H11.4298V9.16441H18.6463V4.70526Z"
        fill="#E7EEF1"
        stroke="#011837"
        stroke-miterlimit="10"
      />
      <path
        d="M25.8629 4.70526H18.6464V9.16441H25.8629V4.70526Z"
        fill="#E7EEF1"
        stroke="#011837"
        stroke-miterlimit="10"
      />
      <path
        d="M20.3114 11.9514L16.9807 13.6236H1.4375V17.5253C1.4375 18.6401 1.6984 19.348 2.06478 19.8664L2.52553 19.4929C3.04733 19.0693 3.73012 19.1083 4.21863 19.5821L5.17342 20.5074C5.37882 20.708 5.61752 20.8251 5.86177 20.8697H6.28365C6.50015 20.8307 6.70554 20.7359 6.89428 20.5743L8.13774 19.5096C8.64844 19.0749 9.33124 19.0916 9.82529 19.5487L10.9022 20.5408C11.0909 20.7136 11.3074 20.8251 11.5295 20.8697H11.9958C12.2178 20.8251 12.4288 20.7192 12.6175 20.552L13.7444 19.5375C14.244 19.086 14.9268 19.0804 15.4319 19.5208L16.631 20.5631C16.8197 20.7248 17.0307 20.8251 17.2416 20.8641H17.6802C17.9189 20.8195 18.1465 20.708 18.3463 20.5185L19.3455 19.5654C19.834 19.0972 20.5224 19.0693 21.0386 19.4985L22.3542 20.5854C22.5374 20.7359 22.7484 20.8307 22.9593 20.8641H23.3534C23.6143 20.8195 23.8641 20.6969 24.0751 20.4851L24.9522 19.5988C25.4351 19.1139 26.1235 19.0637 26.6508 19.4762L27.6223 20.2398C28.3051 17.9266 32.5128 16.1095 32.5128 11.9458H20.3003L20.3114 11.9514Z"
        fill="#6BFFFF"
      />
      <path
        d="M27.6001 20.3123C28.2218 17.9657 32.5239 16.1542 32.5239 11.9514H20.3114L16.9807 13.6236H1.4375V17.5254C1.4375 18.5733 1.65955 19.2644 1.99261 19.7717"
        stroke="#011837"
        stroke-miterlimit="10"
      />
      <path
        d="M29.0103 21.3268L26.6621 19.4818C26.1348 19.0694 25.4464 19.1195 24.9635 19.6044L24.0864 20.4907C23.5923 20.9868 22.8929 21.0258 22.3655 20.591L21.0499 19.5041C20.5337 19.0805 19.8509 19.1028 19.3568 19.571L18.3576 20.5242C17.858 21.0035 17.1586 21.0202 16.6368 20.5687L15.4377 19.5264C14.9326 19.0861 14.2498 19.0916 13.7502 19.5431L12.6233 20.5576C12.1126 21.0202 11.4131 21.0147 10.9024 20.5464L9.8255 19.5543C9.33144 19.0972 8.64865 19.0805 8.13795 19.5153L6.89449 20.5799C6.37268 21.0258 5.67324 20.9979 5.17363 20.513L4.21883 19.5877C3.73033 19.1139 3.04754 19.0749 2.52573 19.4985L0.260864 21.3268"
        stroke="#011837"
        stroke-miterlimit="10"
      />
      <path
        d="M22.5322 14.181H20.8668"
        stroke="#011837"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1138_24638">
        <rect width="33" height="23" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
